var map = {
	"./chevron-down-navbar.svg": "./src/assets/icons/chevron-down-navbar.svg",
	"./chevron-down-select.svg": "./src/assets/icons/chevron-down-select.svg",
	"./chevron-down-sharp.svg": "./src/assets/icons/chevron-down-sharp.svg",
	"./chevron-down.svg": "./src/assets/icons/chevron-down.svg",
	"./chevron-left-sharp.svg": "./src/assets/icons/chevron-left-sharp.svg",
	"./chevron-left.svg": "./src/assets/icons/chevron-left.svg",
	"./chevron-right-sharp.svg": "./src/assets/icons/chevron-right-sharp.svg",
	"./chevron-right-small.svg": "./src/assets/icons/chevron-right-small.svg",
	"./chevron-right-white.svg": "./src/assets/icons/chevron-right-white.svg",
	"./chevron-right.svg": "./src/assets/icons/chevron-right.svg",
	"./chevron-up.svg": "./src/assets/icons/chevron-up.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/icons sync recursive ^\\.\\/chevron\\-.*\\.svg$";